//Angular 6 BUG
(window as any).global = window;
let g = (window as any).global

// HOTFIX: define process
if (typeof window !== "undefined") {
  (window as any).process = { env: {} };
} else if (typeof g !== "undefined") {
  (g as any).process = { env: {} };
}